module.exports = __webpack_public_path__ + "static/media/flower_img_icon.9a6e490f.png";